var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "g-full", attrs: { id: "app" } },
    [
      _c(
        "transition",
        {
          attrs: {
            mode: "out-in",
            "enter-active-class": "animated fadeIn",
            "leave-active-class": "animated fadeOut"
          }
        },
        [
          _c("router-view", {
            staticStyle: { "animation-duration": "1s" },
            attrs: { ondragstart: "return false" },
            on: { listenToChildEvent: _vm.getChildMsg }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: {
            mode: "out-in",
            "enter-active-class": "animated bounceInDown"
          }
        },
        [
          _vm.isLogin
            ? [
                _c("div", { staticClass: "loginName" }, [
                  _c("div", { staticClass: "lab" }, [_vm._v("学号")]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { "text-align": "center" } }, [
                    _vm._v(_vm._s(_vm.$root.postParams.numberId))
                  ])
                ])
              ]
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }